import React, { memo } from 'react';
// styles
import styles from './Option.module.scss';
function Option({ option, index, onOptionSelect, renderFunction, }) {
    const onClick = (e) => {
        if (e.defaultPrevented) {
            return;
        }
        if (!option.disabled) {
            onOptionSelect(option);
        }
    };
    const children = renderFunction(option, index, onClick, `${styles.option} ${styles.option}`);
    return React.createElement(React.Fragment, null, children);
}
export default memo(Option);
